import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParamsGeneric } from '../../../../../core/models/RouteParams';
import { ProjectCooperatorVm, ProjectDetailVm } from '../../../../../utils/api';
import ProjectCooperatorForm from './ProjectCooperatorForm';

interface OwnProps {
    project?: ProjectDetailVm;
    projectCooperator?: ProjectCooperatorVm;
    onClose: () => void;
    onSuccess: (result: ProjectCooperatorVm) => void;
}

export type Props = OwnProps & RouteComponentProps<RouteParamsGeneric>;

export default withRouter(ProjectCooperatorForm);
